import React from 'react'
import Assetlifereports from '../../components/assetlifecyclecomponents/Assetlifereports'

function  Assetlife({renderPageContent}) {
    return (
        <>
                        <Assetlifereports renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Assetlife
